<template>
    <div :class="[cssClass, showImage ? 'has-img' : '']" @click.self="closePopup">
        <div class="popup-container popup-custom">
            <div v-if="showCloseIcon" class="close-icon" @click="closePopup">
                <div class="icon-close-pos"></div>
            </div>
            <div class="img-wrp popup-image" v-if="showImage">
                <img src="@/assets/img/bd-cs.jpg" />
            </div>
            <LanguageSwitch v-if="showLanguageSwitch" />
            <div class="content">
                <h3 v-html="$te(title.text)? $t(title.text, title.i18n || {}) : title.text"></h3>

                <template v-for="(item, i) in content" :key="i">
                    <p v-if="item.type === 'p'" :class="item.cssClass || ''" v-html="$te(item.text) ? $t(item.text, item.i18n || {}) : item.text"></p>
                    <ul v-if="item.type === 'ul'" :class="item.cssClass || ''">
                        <li v-for="(li, j) in item.items" :key="j" :class="li.cssClass || ''" v-html="$te(li.text) ? $t(li.text, li.i18n || {}) : li.text"></li>
                    </ul>
                </template>

                <template v-if="buttons">
                    <button v-for="(button, i) in buttons" :key="i" :class="[button.cssClass || 'btn-1', button.icon && !button.cssClass ? 'btn-m-icon' : !button.cssClass ? 'btn-m' : '']" @click="handleFunction(button.fn || null)">
                        <div v-if="button.icon" :class="`icon-${button.icon}-pos`"></div>
                        <span v-if="button.text">{{$te(button.text) ? $t(button.text, button.i18n || {}) : button.text}}</span>
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { usePopupStore } from '@/stores/utils/popup';
import { mapActions } from 'pinia';
import LanguageSwitch from '@/components/elements/misc/LanguageSwitch';

export default {
    name: 'PopupCustom',
    components: {
        LanguageSwitch
    },
    props: {
        title: Object,
        content: {
            type: Array,
            default: () => []
        },
        buttons: {
            type: Array,
            default: () => []
        },
        showCloseIcon: {
            type: Boolean,
            default: true
        },
        cssClass: {
            type: String,
            default: 'popup-type-1'
        },
        showLanguageSwitch: {
            type: Boolean,
            default: false
        },
        showImage: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        ...mapActions(usePopupStore, ['closePopup']),
        async handleFunction(fn) {
            if (fn && typeof fn === 'function') {
                await fn();
            }
            this.closePopup();
        }
    }
};
</script>
